module.exports = __webpack_public_path__ + "img/icon_t4_c.1abf1bc7.png";